<hypecast-master-admin-dialog-header
  title="You have pending changes"
  class="dialog-header"
  (emitCloseClick)="dialogRef.close(null)"
>
</hypecast-master-admin-dialog-header>

<div class="form-deactivateable-dialog__message">Are you sure to leave the page without saving?</div>

<hypecast-master-admin-dialog-footer>
  <div class="form-deactivateable-dialog__actions flex flex-row">
    <hypecast-master-admin-buttons-cancel class="flex-initial" (onClick)="dialogRef.close(null)"
      >Continue editing
    </hypecast-master-admin-buttons-cancel>
    <hypecast-master-admin-buttons-submit class="ml-1 flex-initial" (onClick)="dialogRef.close(true)"
      >Leave without saving
    </hypecast-master-admin-buttons-submit>
  </div>
</hypecast-master-admin-dialog-footer>
